<template>
  <div class="school-map-side-bar">
    <v-navigation-drawer
      v-model="toogleSideBar"
      right
      hide-overlay
      stateless
      :width="sidebarWidth"
    >
    <v-layout class="toogle-side-bar">
      <v-btn color="white" @click.stop="loadSideBar()">
        <div v-if="loading">
          <v-progress-circular
            :size="25"
            indeterminate
            color="white"
          ></v-progress-circular>
        </div>
        <div v-else>
          <v-icon v-show="toogleSideBar || loading">chevron_right</v-icon>
          <v-icon v-show="(toogleSideBar && loading) || !toogleSideBar">chevron_left</v-icon>
        </div>
      </v-btn>
    </v-layout>
      <v-data-table
        v-if="toogleSideBar"
        ref="schoolMapTableMobile"
        :items="loadedItems"
        hide-actions
        class="school-list-table-card school-list-table-sidebar"
        :no-data-text="$t('No data available')"
      >
        <template v-slot:items="props">
            <td class="text-xs-left">
              <v-layout row wrap class="school-list-row-content">
              <v-flex xs12>
              <v-layout row class="row-name">
                <v-flex xs12>
                  <router-link @click.native="$gtag.event('Learn More List (sidebar)');scrollToTop();" :to="{name: 'schoolpage', params: {province: props.item.province, level: props.item.level, id: props.item.id }}" class="school-name label">{{ props.item.name }}
                  </router-link>
                </v-flex>
                <v-flex xs2 class="text-xs-right field">
                  <v-btn class="email-me"
                         @click.prevent="showNotification = true;
                         province=props.item.province;
                         school_type=props.item.level;
                         school_id=props.item.id;
                         school_name=props.item.name;"
                  ></v-btn>
                </v-flex>
              </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row class="score">
                <v-flex xs6 class="label">{{ $t('Score') }}:</v-flex>
                <v-flex xs6
                  :class="[
                    'text-xs-right',
                    'field',
                    props.item.score >= 0 && props.item.score < 4.1 ? 'score_color_1': '',
                    props.item.score >= 4.1 && props.item.score < 6 ? 'score_color_2': '',
                    props.item.score >= 6 && props.item.score < 7.6 ? 'score_color_3': '',
                    props.item.score >= 7.6 && props.item.score <= 10 ? 'score_color_4': ''
                  ]"
                >{{ props.item.score !== 'n/a' ? parseFloat(props.item.score) : 'n/a' }}</v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row>
                <v-flex xs6 class="label">{{ $t('Rank') }}:</v-flex>
                <v-flex xs6 class="text-xs-right field">{{ props.item.ranking }}/{{schoolTotal}}</v-flex>
                </v-layout>
              </v-flex>
              <!-- <v-flex xs12>
                <v-layout row>
                <v-flex xs6 class="label">{{ $t('Trend') }}:</v-flex>
                <v-flex xs6 class="text-xs-right field trend">
                  <v-icon v-if="props.item.trend == 1" color="#9dc000">trending_up</v-icon>
                  <v-icon v-if="props.item.trend == -1" color="#d32f2f">trending_down</v-icon>
                  <v-icon v-if="props.item.trend == 0" color="#003159">remove</v-icon>
                </v-flex>
                </v-layout>
              </v-flex> -->
              <v-flex xs12>
                <v-layout row>
                <v-flex class="add-to-compare text-xs-left"><v-icon>add_circle</v-icon><a href="#" @click.stop.prevent="$gtag.event('Add to Compare List (sidebar)');addToCompare(props.item)">{{ $t('Add to compare') }}</a></v-flex>
                </v-layout>
              </v-flex>
              </v-layout>
            </td>
        </template>
        <template slot="footer" v-if="schoolsInMapLoaded">
          <infinite-loading @infinite="loadMoreSchools" ref="infiniteLoading">
            <span slot="no-more"/>
          </infinite-loading>
        </template>
      </v-data-table>
    </v-navigation-drawer>

    <SchoolNotification
      :province="province"
      :schoolType="school_type"
      :schoolName="school_name"
      :schoolId="school_id"
      :showNotification="showNotification"
      @sendCloseDialog="showNotification = false"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import InfiniteLoading from 'vue-infinite-loading';
import SchoolNotification from '@/components/SchoolMap/SchoolNotification';

export default {
  components: {
    SchoolNotification,
    InfiniteLoading
  },
  name: "SchoolMapSideBar",
  data() {
    return {
      showNotification: false,
      province: false,
      school_type: false,
      school_id: 0,
      school_name: false,
      loading: false,
      toogleSideBar: true,
      sidebarWidth: 313,
      defaultSidebarWidth: 313,
      search: "",
      selected: [],
      page: 1,
      pageItems: [],
      schoolsMutated: false,
      rowsPerPage: 8,
      headers: [
        {
          text: "School",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Score",
          value: "rating",
          sortable: false
        },
        {
          text: "Compare",
          value: null,
          sortable: false
        }
      ]
    };
  },
  mounted() {},
  computed: {
    ...mapState({
      schoolTotal(state) {
        return state.initialSearchSchoolListFilteredCount;
      },
      schoolsInMap(state) {
        return state.schoolsInMap.sort(function (a, b) {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          return 0;
        });
      },
      schoolsInMapTotal(state) {
        return state.schoolsInMap.length;
      },
      schoolsInMapLoaded(state) {
        return state.schoolsInMap.length > 0;
      },
      compareSchoolTotal(state) {
        return state.compareSchool.length;
      },
      compareSchoolList(state) {
        return state.compareSchool;
      }
    }),
    compareSchool: {
      get: function() {
        return this.$store.state.compareSchool;
      },
    },
    showCompare: {
      get: function(e) {
        if (e.compareSchoolList.length != undefined && e.compareSchoolList.length > 0) {
          this.initChart();
        }
        return this.$store.state.dialogCompareSchool;
      },
      set: function(value) {
        this.$store.commit("SET_DIALOG_COMPARE_SCHOOL", value);
      }
    },
    loadedItems() {

      return this.schoolsInMap.slice(0, this.page * this.rowsPerPage);
    },
    noMoreItems() {
      return this.loadedItems.length === this.schoolsInMap.length;
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0,0);
    },
    loadMoreSchools() {
      this.page++;
      this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');

      if (this.noMoreItems) {
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
      }
    },
    resetPage() {
      this.page = 1;
      this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
    },
    loadSideBar(){
      this.loading = !this.loading;
      setTimeout(()=>{
        this.toogleSideBar = !this.toogleSideBar;
        this.sidebarWidth = this.toogleSideBar ? this.defaultSidebarWidth : 0;
        this.loading = false;
      }, 0);
    },
    paginationGoTo(value) {
      let vm = this;
      vm.pagination.page = value;
    },
    addToCompare(school) {
      let schools = this.$store.state.compareSchool;
      if (
        (schools.filter(function(e) { return e.id === school.id; }).length === 0 ||
        schools.length === 0
        ) &&
        schools.length < 6
        ) {
        schools.push(school);
        this.$store.commit('SET_COMPARE_SCHOOL', schools);
      }
    }
  },
  watch: {
    schoolsInMap: {
      deep: true,
      handler(val) {
        if (val.length !== this.schoolsInMapTotal) {
          this.resetPage();
        }
      }
    }
  }
};
</script>
